export type DeckCapability = { id: string; min: number; max: number; step?: number; angleMin?: number; angleMax?: number }
export type RampCapability = { id: string; states: Array<'stored' | 'deployed' | 'raised' | 'lowered'> }

export function resolveCapabilities(geometry: any): { decks: DeckCapability[]; ramps: RampCapability[] } {
  const decks = Array.isArray(geometry?.decks) ? geometry.decks.filter((deck: any) =>
    deck && deck.adjustable === true && typeof deck.id === 'string' && Number.isFinite(Number(deck.min)) && Number.isFinite(Number(deck.max))
  ).map((deck: any) => ({ id: deck.id, min: Number(deck.min), max: Number(deck.max), step: Number(deck.step) || 1,
    angleMin: Number.isFinite(Number(deck.angleMin)) ? Number(deck.angleMin) : undefined,
    angleMax: Number.isFinite(Number(deck.angleMax)) ? Number(deck.angleMax) : undefined })) : []
  const ramps = Array.isArray(geometry?.ramps) ? geometry.ramps.filter((ramp: any) => ramp && typeof ramp.id === 'string' && Array.isArray(ramp.states) && ramp.states.length > 0)
    .map((ramp: any) => ({ id: ramp.id, states: ramp.states.filter((state: any) => ['stored', 'deployed', 'raised', 'lowered'].includes(state)) })) : []
  return { decks, ramps }
}

export function moveDeck(state: { height: number; angle: number }, capability: DeckCapability, direction: 'up' | 'down' | 'angle-up' | 'angle-down') {
  const step = capability.step ?? 1
  if (direction === 'up' || direction === 'down') return { ...state, height: Math.max(capability.min, Math.min(capability.max, state.height + (direction === 'up' ? step : -step))) }
  const angleStep = step
  const min = capability.angleMin ?? 0
  const max = capability.angleMax ?? 0
  return { ...state, angle: Math.max(min, Math.min(max, state.angle + (direction === 'angle-up' ? angleStep : -angleStep))) }
}
